import {
  ButtonsContainer,
  CancelButton,
  CloseButtonIcon,
  ConfirmButton,
  DataContainer,
  DataTitleText,
  DataValueText,
  StyledModal,
  SubTitleText,
  TitleAndIconContainer,
  TitleAndSubtitleContainer,
  TitleAndValueDataContainer,
  TitleText,
} from './styles'
import closeButtonIcon from '../../assets/close-button.svg'

interface TedConfirmationModalProps {
  isOpen: boolean
  onRequestClose: () => void
  onConfirm: () => void
  value?: string
  owner?: string
  tedTax?: string
  receivingValue?: string
  disabledButtons?: boolean
}

export const TedConfirmationModal = ({
  isOpen,
  onRequestClose,
  onConfirm,
  value,
  owner,
  tedTax,
  receivingValue,
  disabledButtons,
}: TedConfirmationModalProps) => {
  return (
    <StyledModal
      open={isOpen}
      onClose={onRequestClose}
      center
      styles={{
        modal: {
          borderRadius: '8px',
          padding: '24px',
        },
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
        closeIcon: {
          display: 'none',
        },
      }}
    >
      <>
        <TitleAndIconContainer>
          <TitleAndSubtitleContainer>
            <TitleText>Confirmar TED</TitleText>
            <SubTitleText>
              Revise os dados e finalize o pagamento com segurança.
            </SubTitleText>
          </TitleAndSubtitleContainer>
          <CloseButtonIcon onClick={onRequestClose} src={closeButtonIcon} />
        </TitleAndIconContainer>

        <DataContainer>
          <TitleAndValueDataContainer>
            <DataTitleText>Valor do saque</DataTitleText>
            <DataValueText>{value}</DataValueText>
          </TitleAndValueDataContainer>
          <TitleAndValueDataContainer>
            <DataTitleText>Taxa TED</DataTitleText>
            <DataValueText>{tedTax}</DataValueText>
          </TitleAndValueDataContainer>
          <TitleAndValueDataContainer>
            <DataTitleText>Titular</DataTitleText>
            <DataValueText>{owner}</DataValueText>
          </TitleAndValueDataContainer>
          <TitleAndValueDataContainer>
            <DataTitleText>Valor a receber</DataTitleText>
            <DataValueText>{receivingValue}</DataValueText>
          </TitleAndValueDataContainer>
        </DataContainer>

        <ButtonsContainer>
          <CancelButton onClick={onRequestClose} disabled={disabledButtons}>
            Cancelar
          </CancelButton>
          <ConfirmButton onClick={onConfirm} disabled={disabledButtons}>
            Confirmar
          </ConfirmButton>
        </ButtonsContainer>
      </>
    </StyledModal>
  )
}
